export const socialsData = {
    github: 'https://github.com/CoderAnnu',
    linkedIn: 'https://www.linkedin.com/in/anand-rajput012/',
    codepen: 'https://codepen.io/coderAnnu',
    stackOverflow: 'https://stackoverflow.com/users/19826921/coderannu',
    
    codesandbox:'https://codesandbox.io/u/CoderAnnu',
    // buymeacoffee:'https://www.buymeacoffee.com/coderannu',
    // leetcode:'https://leetcode.com/CoderAnnu/',
    // CssBattle:'https://cssbattle.dev/player/coderannu',
    
    // facebook: 'https://www.facebook.com/',
    instagram: 'https://www.instagram.com/',
    // twitter: 'https://twitter.com/',
    // reddit: 'https://www.reddit.com/user/',
    // blogger: 'https://www.blogger.com/',
    // gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/'
}